import request from 'assets/js/http';
// 获取OKTA跳转链接
export function getTraceList(data) {
  return request({
    url: '/trace/list',
    method: 'post',
    data: data
  });
}
export function traceArtificial(data) {
  return request({
    url: '/trace/artificial',
    method: 'post',
    data: data
  });
}
export function traceSiteQuery() {
  return request({
    url: '/trace/siteQuery',
    method: 'post'
  });
}
export function setTraceSite(data) {
  return request({
    url: '/trace/site',
    method: 'post',
    data: data
  });
}
export function isTrace(data) {
  return request({
    url: '/trace/ifTrace',
    method: 'post',
    data: data
  });
}
